import { report, REPORT_TYPES } from '@adsk/exo-skeleton-api';

import { EXO_SKELETON_SCOPE_NAME } from '../consts';

function getServiceWorkerUrl() {
  const uniqueBuildId = process.env.APPLICATION_UNIQUE_BUILD_ID;
  const serviceWorkerUrl = `${__webpack_public_path__ || '/'}service-worker.js${typeof uniqueBuildId === 'string' ? `?${uniqueBuildId}` : ''}`;
  return serviceWorkerUrl;
}

export function initializeServiceWorker({
  disabled = false,
}: { disabled?: boolean } = {}) {
  if ('serviceWorker' in navigator) {
    const serviceWorkerUrl = getServiceWorkerUrl();

    navigator.serviceWorker
      .getRegistration()
      .then((registration) => {
        if (disabled && registration) {
          return registration.unregister().then(() =>
            report({
              type: REPORT_TYPES.info,
              value: 'service-worker-unregistered',
              scope: EXO_SKELETON_SCOPE_NAME,
              context: {},
            }),
          );
        } else {
          return null;
        }
      })
      .catch((error) => {
        report({
          type: REPORT_TYPES.error,
          value: error,
          scope: EXO_SKELETON_SCOPE_NAME,
          context: {
            error,
            serviceWorkerUrl,
          },
        });
      });

    if (disabled) {
      return;
    }

    navigator.serviceWorker
      .register(serviceWorkerUrl, { scope: '/', updateViaCache: 'all' })
      .then(() => {
        report({
          type: REPORT_TYPES.info,
          value: 'service-worker-registered',
          scope: EXO_SKELETON_SCOPE_NAME,
          context: {
            serviceWorkerUrl,
          },
        });
      })
      .catch((registrationError) => {
        report({
          type: REPORT_TYPES.error,
          value: registrationError,
          scope: EXO_SKELETON_SCOPE_NAME,
          context: {
            error: registrationError,
            serviceWorkerUrl,
          },
        });
      });
  }
}
